/**
 * Baidu 统计分析脚本 & Google Analytics
 * @author wuyuyong
 * @host www.yzdli.com 正式
 */

/**
 * 设置 Google Analytics 和百度统计。
 * @param {object} router - Vue Router 实例
 */
export function setupGoogleAnalytics(router) {
  // 确保只在客户端和特定生产环境中执行
  if (typeof window !== 'undefined' && process.env.RELEASE === 'stable' && window.location.host.includes('yzdli.com')) {
    /*
     ** Google 统计分析脚本
     */
    /* eslint-disable */
    ;(function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r
      ;((i[r] =
        i[r] ||
        function () {
          ;(i[r].q = i[r].q || []).push(arguments)
        }),
        (i[r].l = 1 * new Date()))
      ;((a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]))
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga')

    /*
     ** 当前页的访问统计
     */
    ga('create', 'G-PWX9KZXKFF', 'auto')

    /* 当路由改变的时候,推送一次 */
    router.afterEach((to, from) => {
      // console.log(to.path);
      try {
        const firstLevelPath = to.path.split('/')[1]
        // 中台页面不做记录
        const notRecordFirstLevelPath = ['visitor', 'organizer', 'exhibitor', 'contractors', 'designer']

        if (!notRecordFirstLevelPath.includes(firstLevelPath)) {
          // 百度统计
          window._hmt = window._hmt || []
          window._hmt.push(['_trackPageview', to.fullPath])
          // console.log('百度统计路径:', to.fullPath)

          /*
           ** 告诉 GA 增加一个 PV
           */
          ga('set', 'page', to.fullPath)
          ga('send', 'pageview')
        }
      } catch (e) {}
    })
  }
}
